import { render, staticRenderFns } from "./PendingPopup.vue?vue&type=template&id=0b9dcacf&scoped=true"
import script from "./PendingPopup.vue?vue&type=script&lang=js"
export * from "./PendingPopup.vue?vue&type=script&lang=js"
import style0 from "./PendingPopup.vue?vue&type=style&index=0&id=0b9dcacf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9dcacf",
  null
  
)

export default component.exports